import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';

/**
 * REV-22548: the one rule for "the saved notes are older than grouping, mapping or the trial
 * balance". The notes page shows its «Änderungen erkannt» banner from it and Abschluss & Druck
 * warns from it, so both pages always agree.
 */
export class NotesVersionHelper {
    static isNotesOutOfDate(annualReport: IAnnualReport, isFcpActive: boolean): boolean {
        if (annualReport?.notes == null) {
            return false;
        }

        if (isFcpActive && annualReport.fcp != null) {
            return annualReport.fcp.version !== annualReport.notes.version;
        }

        const statementsVersion = annualReport.finStatements?.[0]?.version;
        // Old reports never versioned their statements, so there is nothing to compare against.
        if (statementsVersion == null) {
            return false;
        }

        return statementsVersion !== annualReport.notes.version;
    }
}
